// src/components/StepProgressBar.jsx
import React from 'react';
export default function StepProgressBar({
  step,
  getStepPercent,
  loading,
  error,
  showPage2Progress = true,
}) {
  const pProfile = getStepPercent('profile');
  const pMain = getStepPercent('battleMain');
  const pPage2 = showPage2Progress ? getStepPercent('battleMain2') : 0;
  const isActiveStep = ['profile', 'battleMain', 'battleMain2'].includes(step);
  const curPct = isActiveStep
    ? (step === 'profile' ? pProfile : step === 'battleMain' ? pMain : pPage2)
    : 0;
  let displayStep = step;
  let pct = 0;
  if (isActiveStep && (loading || curPct > 0)) {
    displayStep = step;
    pct = curPct;
  } else {
    const candidates = [
      { key: 'battleMain2', val: pPage2 },
      { key: 'battleMain', val: pMain },
      { key: 'profile', val: pProfile },
    ].filter(c => c.val > 0);
    if (candidates.length > 0) {
      const best = candidates.sort((a, b) => b.val - a.val)[0];
      displayStep = best.key;
      pct = best.val;
    }
  }
  if (!displayStep) return null;
  const colorMap = {
    profile: '#06b6d4',   // cyan-500
    battleMain: '#10b981', // emerald-500
    battleMain2: '#8b5cf6' // violet-500
  };
  const labelMap = {
    profile: '캐릭터 정보 인식',
    battleMain: '전투 분석기 인식',
    battleMain2: '스크롤 후 전투 분석기 인식'
  };
  const label = labelMap[displayStep] || '';
  const color = colorMap[displayStep] || '#10b981';
  return (
    <div className='mt-4 mb-4 relative'>
      <div className='text-xs absolute -translate-y-full pb-2 text-zinc-700 dark:text-zinc-300'>
        <span>{label}</span>&nbsp;
        {isActiveStep && pct > 0 && (
          <span>{pct}%</span>
        )}
        {error && <p className='text-rose-700 dark:text-rose-400'>{String(error)}</p>}
      </div>
      <div
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct}
        className='w-full bg-gray-200 dark:bg-gray-700 h-px overflow-hidden'
      >
        <div
          style={{
            width: `${pct}%`,
            height: '100%',
            background: color,
            transition: 'width 200ms ease'
          }}
        />
      </div>
    </div>
  );
}
